import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { renderPageStyle } from "../../utils/Utils";


const DeliveryReport = () => {
  const historyDom = useHistory();

  const printRef = useRef();
  const [smOption, setSmOption] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [filterDate, setFilterDate] = useState(
    searchParams.get("filterDate") || moment().format("YYYY-MM-DD")
  );
  const [data, setData] = useState({});
  const [summary, setSummary] = useState({});

  useEffect(() => {
    const newParams = new URLSearchParams({
      filterDate,
    });
    historyDom.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      `/report/delivery`,
      {
        date: filterDate,
      },
      true
    ).then((resp) => {
      const {
        data: { data, summary },
      } = resp;
      setData(data);
      setSummary(summary);
    });
  }, [filterDate]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      date: moment(filterDate).format("YYYY-MM-DD"),
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL
      }/api/v1/report/delivery-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <div className="toggle-wrap nk-block-tools-toggle">
              <a
                href="#more"
                className="btn btn-icon btn-trigger toggle-expand mr-n1"
                onClick={(ev) => {
                  ev.preventDefault();
                  setSmOption(!smOption);
                }}
              >
                <Icon name="more-v"></Icon>
              </a>
              <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                  <li>
                    <div className="form-group">
                      <div className="form-control-wrap">
                        <input
                          onChange={(e) =>
                            setFilterDate(moment(e.target.value).format("YYYY-MM-DD"))
                          }
                          placeholder="Lọc theo ngày"
                          value={filterDate}
                          type="date"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="d-inline-block mr-3">
                      <ReactToPrint
                        trigger={() => <Button>In</Button>}
                        content={() => printRef.current}
                        pageStyle={``}
                      />
                      <Button onClick={exportExcel} className="ml-3">
                        Xuất excel
                      </Button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Row className="mb-3">
            <Col size={3}>

            </Col>
            <Col size={3}>

            </Col>
            <Col size={6} className="d-inline-block">

            </Col>
          </Row>

          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_1_length"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row>
                {data ? (
                  <Col md={12}>
                    <div ref={printRef}>
                      <style>{renderPageStyle()}</style>
                      <h5 className="text-center">Báo cáo giá net và vận chuyển ngày {moment(filterDate).format('DD-MM-YYYY')} </h5>

                      <table
                        className="table-bordered w-100 table table-responsive"
                      >
                        <tbody>
                          <tr style={{ backgroundColor: "#91d14f" }}>
                            <td style={{ textAlign: "center" }} colSpan={12}>
                              QUẢN LÍ GIÁ NET VÀ VẬN CHUYỂN
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "#91d14f" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              Ngày
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              Lũy kế tháng
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              Lũy kế năm
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "#93ffc2" }}>
                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá NET(vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>

                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá NET(vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>

                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá NET(vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>
                          </tr>

                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              CHI TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LŨY KẾ CHI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ CHI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {data?.netIn?.day.map((day, idx) => {
                            const { name, weight, price, total } = day;
                            const month = data?.netIn?.month[idx];
                            const year = data?.netIn?.year[idx];
                            return (
                              <tr>
                                <td>{name}</td>
                                <td>
                                  <NumericFormat
                                    value={weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{month.name}</td>
                                <td>
                                  <NumericFormat
                                    value={month.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{year.name}</td>
                                <td>
                                  <NumericFormat
                                    value={year.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Chi
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netInDayTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế chi tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netInMonthTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế chi tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netInYearTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                          </tr>

                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              THU TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LŨY KẾ THU TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ THU TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {data?.netOut?.day.map((day, idx) => {
                            const { name, weight, price, total } = day;
                            const month = data?.netOut?.month[idx];
                            const year = data?.netOut?.year[idx];
                            return (
                              <tr>
                                <td>{name}</td>
                                <td>
                                  <NumericFormat
                                    value={weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{month.name}</td>
                                <td>
                                  <NumericFormat
                                    value={month.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{year.name}</td>
                                <td>
                                  <NumericFormat
                                    value={year.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Thu
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netOutDayTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế thu tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netOutMonthTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế thu tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.netOutYearTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                          </tr>

                          {/* delivery */}

                          <tr style={{ backgroundColor: "#93ffc2" }}>
                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá Vận chuyển (vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>

                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá Vận chuyển (vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>

                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá Vận chuyển (vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>
                          </tr>

                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              CHI TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LŨY KẾ CHI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ CHI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {data?.deliveryIn?.day.map((day, idx) => {
                            const { name, weight, price, total } = day;
                            const month = data?.deliveryIn?.month[idx];
                            const year = data?.deliveryIn?.year[idx];
                            return (
                              <tr>
                                <td>{name}</td>
                                <td>
                                  <NumericFormat
                                    value={weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{month.name}</td>
                                <td>
                                  <NumericFormat
                                    value={month.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{year.name}</td>
                                <td>
                                  <NumericFormat
                                    value={year.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Chi
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryInDayTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế chi tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryInMonthTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế chi tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryInYearTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                          </tr>

                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              THU TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LŨY KẾ THU TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ THU TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {data?.deliveryOut?.day.map((day, idx) => {
                            const { name, weight, price, total } = day;
                            const month = data?.deliveryOut?.month[idx];
                            const year = data?.deliveryOut?.year[idx];
                            return (
                              <tr>
                                <td>{name}</td>
                                <td>
                                  <NumericFormat
                                    value={weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{month.name}</td>
                                <td>
                                  <NumericFormat
                                    value={month.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={month.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>

                                <td>{year.name}</td>
                                <td>
                                  <NumericFormat
                                    value={year.weight || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.price || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    value={year.total || 0}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    displayType="text"
                                  />
                                </td>
                              </tr>
                            );
                          })}

                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Thu
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryOutDayTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế thu tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryOutMonthTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế thu tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat
                                value={summary.deliveryOutYearTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                          </tr>

                          <tr style={{ backgroundColor: "#e4dfed" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              TỔNG VẬN CHUYỂN TRONG NGÀY
                            </td>
                            <td>
                              <NumericFormat
                                value={summary.deliveryDayTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              LŨY KẾ TỔNG VẬN CHUYỂN TỚI HIỆN TẠI
                            </td>
                            <td>
                              <NumericFormat
                                value={summary.deliveryMonthTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              LŨY KẾ TỔNG VẬN CHUYỂN TỚI HIỆN TẠI
                            </td>
                            <td>
                              <NumericFormat
                                value={summary.deliveryYearTotal}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                displayType="text"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>
          </div>
        </Block>
      </Content>
      {/* <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Biểu đồ</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Card>
            <CardBody>
              <Row>
                <Col sm={12} md={6}>
                  <h3>Nhập kho theo ngày</h3>

                  <Doughnut data={chartData?.inDay} />
                </Col>
                <Col sm={12} md={6}>
                  <h3>Xuất kho theo ngày</h3>
                  <Doughnut data={chartData?.outDay} />
                </Col>
                <Col sm={12} md={6}>
                  <h3>Nhập kho theo tháng</h3>

                  <Doughnut data={chartData?.inMonth} />
                </Col>
                <Col sm={12} md={6}>
                  <h3>Xuất kho theo tháng</h3>
                  <Doughnut data={chartData?.outMonth} />
                </Col>
                <Col sm={12} md={6}>
                  <h3>Nhập kho theo năm</h3>

                  <Doughnut data={chartData?.inYear} />
                </Col>
                <Col sm={12} md={6}>
                  <h3>Xuất kho theo năm</h3>
                  <Doughnut data={chartData?.outYear} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Block>
      </Content> */}
    </React.Fragment>
  );
};

export default DeliveryReport;
